import _styled from "styled-components";
import React from 'react';
import { BREAKPOINT } from '@latitude/core/utils/constants';
export default (function () {
  var paths = typeof window !== 'undefined' && window.location.pathname.split('/');
  paths = paths[paths.length - 1] === '' ? paths.slice(0, paths.length - 1) : paths;
  var breadcrumb = typeof window !== 'undefined' && paths.map(function (path, index) {
    var pageName = path.charAt(0).toUpperCase() + path.slice(1).replaceAll('-', ' ');

    if (index === 0) {
      return /*#__PURE__*/React.createElement("li", {
        className: "breadcrumb-item"
      }, /*#__PURE__*/React.createElement("a", {
        key: index,
        href: "/"
      }, "Home"));
    }

    var url = paths.slice(0, index + 1).join('/');
    return /*#__PURE__*/React.createElement("li", {
      className: "breadcrumb-item"
    }, /*#__PURE__*/React.createElement("a", {
      key: index,
      href: url
    }, pageName));
  });
  return /*#__PURE__*/React.createElement(_StyledNav, {
    "aria-label": "breadcrumb",
    $_css: BREAKPOINT.MD,
    $_css2: BREAKPOINT.MD,
    $_css3: BREAKPOINT.LG,
    $_css4: BREAKPOINT.LG,
    $_css5: BREAKPOINT.XL
  }, /*#__PURE__*/React.createElement("ol", {
    className: "breadcrumb"
  }, breadcrumb));
});

var _StyledNav = /*#__PURE__*/_styled("nav").withConfig({
  displayName: "Breadcrumb___StyledNav",
  componentId: "sc-8f7cbj-0"
})(["align-self:flex-start;margin:24px auto 0;padding:0;width:100%;position:relative;z-index:2;padding:0 16px;@media (min-width:", "){padding:0;max-width:calc(", " - 30px);}@media (min-width:", "){max-width:calc(", " - 30px);}@media (min-width:", "){max-width:calc(1140px - 30px);}.breadcrumb{margin:0;padding:0;list-style-type:none;}.breadcrumb-item{display:inline-block;padding-right:20px;position:relative;font-size:14px;&:after{content:'/';display:block;position:absolute;right:10px;top:0;}&:last-of-type{a{text-decoration:none;color:#42484d;border:none;}&:after{display:none;}}}"], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
}, function (p) {
  return p.$_css3;
}, function (p) {
  return p.$_css4;
}, function (p) {
  return p.$_css5;
});